import React from "react";

export default function Logo({ size = 44 }) {
  // Sphere with orbiting icons (magnet, light, DNA, gear)
  const s = size;
  return (
    <svg
      width={s}
      height={s}
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="edusphere-logo"
      aria-label="EduSphere logo"
    >
      {/* outer orbit ring */}
      <ellipse cx="32" cy="32" rx="28" ry="10" fill="none" stroke="#3A5A40" strokeWidth="1.4" opacity="0.55" transform="rotate(-25 32 32)" />
      {/* inner orbit ring */}
      <ellipse cx="32" cy="32" rx="28" ry="10" fill="none" stroke="#E07A5F" strokeWidth="1.4" opacity="0.7" transform="rotate(35 32 32)" />
      {/* sphere */}
      <circle cx="32" cy="32" r="11" fill="#E07A5F" />
      <circle cx="32" cy="32" r="11" fill="url(#sphereGrad)" />
      {/* orbiting icons */}
      {/* light bulb */}
      <circle cx="58" cy="22" r="3" fill="#F4A261" />
      {/* DNA dot */}
      <circle cx="6" cy="42" r="3" fill="#3A5A40" />
      {/* gear */}
      <circle cx="48" cy="56" r="3" fill="#1A1A1A" />
      {/* magnet */}
      <circle cx="14" cy="10" r="3" fill="#E07A5F" />
      <defs>
        <radialGradient id="sphereGrad" cx="0.35" cy="0.35" r="0.7">
          <stop offset="0%" stopColor="#FBE7DF" stopOpacity="0.85" />
          <stop offset="100%" stopColor="#E07A5F" stopOpacity="0" />
        </radialGradient>
      </defs>
    </svg>
  );
}
